import { render, staticRenderFns } from "./subCategory.vue?vue&type=template&id=eae5479c&scoped=true&"
import script from "./subCategory.vue?vue&type=script&lang=js&"
export * from "./subCategory.vue?vue&type=script&lang=js&"
import style0 from "./subCategory.vue?vue&type=style&index=0&id=eae5479c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae5479c",
  null
  
)

export default component.exports